import { useCrudActions } from '@/common/view/useCrudActions';
import { passwordService } from '@/services/password';
import useVuelidate from '@vuelidate/core';
import { email, helpers, integer, or, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useAccountPassword() {
    const model = reactive({
        email: '',
        password: '',
        repassword: ''
    });

    const validations = {
        email: { required, validValue: helpers.withMessage('Incorrect format', or(integer, email)) },
        password: { required },
        repassword: {
            required,
            validValue: helpers.withMessage('Passwords do not match', (value: any) => value === model.password)
        }
    };

    const v$ = useVuelidate(validations, model);

    const { excuteAndNotify } = useCrudActions();
    const actions = {
        update: excuteAndNotify({
            validator: v$,
            request: () => {
                const isAccountId = /^\d+$/.test(model.email);
                const accountId = isAccountId ? model.email : null;
                const email = isAccountId ? null : model.email;
                return passwordService.update(accountId, email, model.password);
            },
            onSuccess: () => {
                // refresh model
                v$.value.$reset();
                model.email = '';
                model.password = '';
                model.repassword = '';
            }
        })
    };

    return { model, v$, fetch, actions };
}
